import type { Maybe } from '@vrplatform/utils';
import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import type { FormattedStatement } from '@vrplatform/ui-common';
import type { ComponentProps, PropsWithChildren } from 'react';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 10,
    fontSize: 8,
    paddingBottom: 40,
    color: '#2C2D35',
  },
  footerContainer: {
    position: 'absolute',
    bottom: 15,
    left: 0,
    right: 0,
    flexDirection: 'column',
  },

  footerText: {
    fontSize: 8,
    textAlign: 'center',
    color: '#707786',
  },

  header: {
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  headline: { marginBottom: 4, fontSize: 16, fontFamily: 'Helvetica-Bold' },
  subline: { fontSize: 10, color: '#707786' },

  logo: {
    width: 35,
    height: 35,
    marginRight: 10,
    objectFit: 'contain',
  },
});

type Props = {
  teamName: Maybe<string>;
  month: Maybe<string>;
  teamLogo: Maybe<string>;
  footer: FormattedStatement['footer'];
  subline: Maybe<string>;
} & ComponentProps<typeof Page>;

export const StatementPageContainer = ({
  children,
  size = 'A4',
  month: _month,
  teamName,
  footer,
  teamLogo,
  subline,
  ...props
}: PropsWithChildren<Props>) => {
  const logo = teamLogo;

  return (
    <Page orientation="landscape" size={size} {...props} style={styles.page}>
      <View
        style={styles.header}
        fixed
        render={({ pageNumber }) => {
          if (pageNumber === 1) return null;

          return (
            <View style={{ display: 'flex', flexDirection: 'row' }}>
              {logo && <Image src={logo} style={styles.logo} />}
              <View>
                <Text style={styles.headline}>{teamName}</Text>
                <Text style={styles.subline}>{subline}</Text>
              </View>
            </View>
          );
        }}
      />

      {children}

      {/* Page Number */}
      <View fixed style={styles.footerContainer}>
        <Text
          style={{ ...styles.footerText, marginBottom: 3 }}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
        />
        {/* <Text style={{ ...styles.footerText, marginBottom: 3 }}>{footer}</Text> */}
        <Text key="pages" style={styles.footerText} id="pages" />
      </View>
    </Page>
  );
};
